import React, { useState, useEffect } from 'react';
import styles from './style.module.css';
import HealthCustomCard from '../../../../../Components/HealthCustomCard';
import { updateProductField, updateTreatmentField } from '../../../../../services/kollectaHealthCore';
import editIcon from './edit.svg';
import modalRed from '../redModalIcon.svg';
import modalGreen from '../greenModalIcon.svg';
import * as moment from 'moment';
import Modal from '../../../../../Components/Modal';
import DatePicker from '../../../../../Components/DatePicker';
import { usePatient } from '../../../../../Contexts/PatientContext';
import cidCodesData from '../../../../../Data/cidCodes.json';

// Enum Estadiamento conforme definido no schema do Prisma
const ESTADIAMENTO_OPTIONS = [
  { value: 'ZERO', label: 'Zero' },
  { value: 'I', label: 'I' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'IV', label: 'IV' },
  { value: 'desconhecido', label: 'Desconhecido' }
];

// Opções de CID
const CID_OPTIONS = cidCodesData.map(code => ({ value: code, label: code }));

// Campos que pertencem ao modelo Treatment
const TREATMENT_FIELDS = [
  'previousSystemicOncoTherapy',
  'previousRadiationTherapy',
  'previousOncoSurgery'
];

const DetailsCard = () => {
  const { patientData, updatePatient } = usePatient();
  const [product, setProduct] = useState({ normalItems: [], uniqueRowItem: null });
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [editData, setEditData] = useState({ field: '', label: '', fieldKey: '', type: '' });
  console.log('DetailsCard', patientData);

  useEffect(() => {
    if (patientData) {
      const normalItems = [
        {
          label: 'Data do Diagnóstico',
          field: patientData.diagnosticAt && moment(patientData.diagnosticAt).isValid() 
            ? moment(patientData.diagnosticAt).format('DD/MM/YYYY') 
            : '',
          editable: true,
          type: 'date',
          fieldKey: 'diagnosticAt'
        },
        {
          label: 'CID',
          field: patientData.cid || '',
          editable: true,
          type: 'cid',
          fieldKey: 'cid'
        },
        {
          label: 'Estadiamento',
          field: patientData.ajcc || '',
          editable: true,
          type: 'estadiamento',
          fieldKey: 'ajcc'
        },
        {
          label: 'Faz Terapia Sistêmica?',
          field: patientData.treatments && patientData.treatments.length > 0 
            ? (patientData.treatments[patientData.treatments.length - 1].previousSystemicOncoTherapy ? 'Sim' : 'Não') 
            : '',
          editable: true,
          type: 'boolean',
          fieldKey: 'previousSystemicOncoTherapy'
        },
        {
          label: 'Faz RT?',
          field: patientData.treatments && patientData.treatments.length > 0 
            ? (patientData.treatments[patientData.treatments.length - 1].previousRadiationTherapy ? 'Sim' : 'Não') 
            : '',
          editable: true,
          type: 'boolean',
          fieldKey: 'previousRadiationTherapy'
        },
        {
          label: 'Fez Cirurgias?',
          field: patientData.treatments && patientData.treatments.length > 0 
            ? (patientData.treatments[patientData.treatments.length - 1].previousOncoSurgery ? 'Sim' : 'Não') 
            : '',
          editable: true,
          type: 'boolean',
          fieldKey: 'previousOncoSurgery'
        },
        {
          label: 'Comorbidades',
          field: patientData.comorbidities || '',
          editable: true,
          type: 'text',
          fieldKey: 'comorbidities'
        }
      ];

      setProduct({ normalItems, uniqueRowItem: null });
    }
  }, [patientData]);

  const handleEdit = (item) => {
    setEditData(item);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    setConfirmModalOpen(true);
  };

  const handleConfirmSave = async () => {
    try {
      let newValue = editData.field;
      
      // Formata o valor com base no tipo
      if (editData.type === 'date' && editData.field) {
        newValue = moment(editData.field, 'DD/MM/YYYY').toISOString();
      } else if (editData.type === 'boolean') {
        newValue = editData.field === 'Sim';
      }

      // Verifica se o campo pertence ao modelo Treatment
      if (TREATMENT_FIELDS.includes(editData.fieldKey)) {
        // Obtém o ID do tratamento atual
        const currentTreatmentId = patientData.treatments && patientData.treatments.length > 0 
          ? patientData.treatments[patientData.treatments.length - 1].id 
          : null;
          
        if (!currentTreatmentId) {
          throw new Error('Não foi possível encontrar o tratamento atual');
        }
        
        // Atualiza o campo do tratamento
        await updateTreatmentField(currentTreatmentId, editData.fieldKey, newValue);
        
        // Atualiza o estado local
        const updatedTreatments = [...patientData.treatments];
        if (updatedTreatments.length > 0) {
          updatedTreatments[updatedTreatments.length - 1] = {
            ...updatedTreatments[updatedTreatments.length - 1],
            [editData.fieldKey]: newValue
          };
        }
        
        updatePatient({ 
          ...patientData, 
          treatments: updatedTreatments 
        });
      } else {
        // Atualiza o campo do produto
        await updateProductField(patientData.id, editData.fieldKey, newValue);
        
        // Atualiza o estado local
        updatePatient({ 
          ...patientData, 
          [editData.fieldKey]: newValue 
        });
      }

      setSuccessModal(true);
    } catch (error) {
      console.error('Erro ao atualizar campo:', error);
      setErrorModal(true);
    } finally {
      setConfirmModalOpen(false);
      setEditModalOpen(false);
    }
  };

  useEffect(() => {
    if (editModalOpen) {
      window.scrollTo(0, 0);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [editModalOpen]);

  const renderEditInput = () => {
    if (editData.type === 'date') {
      return (
        <DatePicker
          selectedDate={editData.field && moment(editData.field, 'DD/MM/YYYY').isValid() 
            ? moment(editData.field, 'DD/MM/YYYY').toDate() 
            : new Date()}
          onDateChange={(date) => setEditData({ ...editData, field: moment(date).format('DD/MM/YYYY') })}
          minDateEnabled={false}
        />
      );
    } else if (editData.type === 'boolean') {
      return (
        <div className={styles.booleanOptions}>
          <button 
            className={`${styles.booleanButton} ${editData.field === 'Sim' ? styles.selected : ''}`}
            onClick={() => setEditData({ ...editData, field: 'Sim' })}
          >
            Sim
          </button>
          <button 
            className={`${styles.booleanButton} ${editData.field === 'Não' ? styles.selected : ''}`}
            onClick={() => setEditData({ ...editData, field: 'Não' })}
          >
            Não
          </button>
        </div>
      );
    } else if (editData.type === 'estadiamento') {
      return (
        <div className={styles.estadiamentoOptions}>
          {ESTADIAMENTO_OPTIONS.map((option) => (
            <button
              key={option.value}
              className={`${styles.estadiamentoButton} ${editData.field === option.value ? styles.selected : ''}`}
              onClick={() => setEditData({ ...editData, field: option.value })}
            >
              {option.label}
            </button>
          ))}
        </div>
      );
    } else if (editData.type === 'cid') {
      return (
        <div className={styles.cidOptions}>
          <select 
            value={editData.field} 
            onChange={(e) => setEditData({ ...editData, field: e.target.value })}
            className={styles.cidSelect}
          >
            <option value="">Selecione um CID</option>
            {CID_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      );
    }
    return (
      <input
        type="text"
        value={editData.field}
        onChange={(e) => setEditData({ ...editData, field: e.target.value })}
      />
    );
  };

  return (
    <HealthCustomCard noPadding>
      <section className={styles.wrapper}>
        <div className={styles.detailCard}>
          {product.normalItems.map((item, index) => (
            <div className={styles.detailCardItem} key={index}>
              <h1>{item.label}</h1>
              <div className={styles.editContainer}>
                <p>{item.field}</p>
                {item.editable && (
                  <img
                    src={editIcon}
                    alt="Edit"
                    className={styles.editIcon}
                    onClick={() => handleEdit(item)}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        {editModalOpen && (
          <Modal onClose={() => setEditModalOpen(false)}>
            <div className={styles.containerModal}>
              <h2>Editar {editData.label}</h2>
              {renderEditInput()}
              <div className={styles.buttonsContainer}>
                <button onClick={handleSaveEdit} className={styles.buttonSuccess}>Continuar</button>
              </div>
            </div>
          </Modal>
        )}
        {confirmModalOpen && (
          <Modal onClose={() => setConfirmModalOpen(false)}>
            <div className={styles.containerModal}>
              <img src={modalRed} alt="Red Modal Icon" />
              <p>Tem certeza que deseja continuar com a alteração da doença?</p>
              <div className={styles.buttonsContainer}>
                <button onClick={handleConfirmSave} className={styles.buttonSuccess}>Continuar</button>
                <button onClick={() => setConfirmModalOpen(false)} className={styles.buttonError}>Cancelar</button>
              </div>
            </div>
          </Modal>
        )}
        {successModal && (
          <Modal onClose={() => setSuccessModal(false)}>
            <div className={styles.containerModal}>
              <img src={modalGreen} alt="Green Modal Icon" />
              <h2>Campo Alterado</h2>
            </div>
          </Modal>
        )}
        {errorModal && (
          <Modal onClose={() => setErrorModal(false)}>
            <div className={styles.containerModal}>
              <img src={modalRed} alt="Red Modal Icon" />
              <h2>Erro ao alterar campo</h2>
              <p>Tente novamente</p>
            </div>
          </Modal>
        )}
      </section>
    </HealthCustomCard>
  );
};

export default DetailsCard;
